module.exports = __webpack_public_path__ + "static_pc/img/s06.0c1f5192.png";